import base from './base';

export default {
  ...base,
  captchaSiteKey: '6LeqinQfAAAAAL4hLxU1buyGpWS6CnU4zxEsztTc'
};
